module.exports = __webpack_public_path__ + "static/assets/692aa5b4c045007350a19f4eda7ba846.png";